import { service } from './index';
import _ from 'lodash';
export const name = 'NUM.render';
const IS_FLOAT_NUMBER_REGX = /^(-)?[\d]+(\.[\d]+)?$/;
function isNumber(uri) {
    return IS_FLOAT_NUMBER_REGX.test(uri);
}
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    const render = (
    // @ts-ignore
    <div class="xtable-cell-render" attrs={attrs}>
            {row[column.property]}
        </div>);
    return [render];
}
// 可编辑显示模板
const renderCell = renderDefault;
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
// 校验
function validator(num) {
    return _.isEmpty(num) || (isNumber(num) && num.length <= 15);
}
// 可编辑激活模板
function renderEdit(h, renderOpts, params) {
    const { row, column } = params;
    const attrs = service.getRenderAttrs(row, column, name);
    const editor = (
    // @ts-ignore
    <div class="xtable-cell-editor" attrs={attrs}>
            <textarea 
    // @ts-ignore
    onchange={e => validator(e.target.value) && service.updateCellValue(row, column, _.trim(e.target.value))} maxlength="15">
                {row[column.property]}
            </textarea>
        </div>);
    this.$nextTick(() => {
        service.updateEditorRect(editor, row, column);
    });
    return [editor];
}
export default {
    renderDefault,
    renderEdit,
    renderCell,
    exportMethod,
    validator,
};
